import Thumbnail from './thumbnail.png';

const title = 'StyLit Paper Reimplementation';
const description = `An implementation of Fišer et al.’s StyLit algorithm for CSCI 2240: Interactive Computer Graphics.`;

export default {
  title,
  description,
  thumbnail: Thumbnail,
  href: 'https://github.com/dcharata/StyLit',
};
